module.exports = __webpack_public_path__ + "static/media/Take Me On Down - Instrumental Version.4b331175.jpg";